/** Coerce unknown form field values to strings without `[object Object]` surprises. */
export function unknownToFormString(value: unknown, fallback = ''): string {
  if (value == null || value === '') return fallback;
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean')
    return String(value);
  return fallback;
}
